import { all, takeEvery, put, fork } from 'redux-saga/effects';

import axios from './initialize'
import { Modal } from 'antd';
import {CheckCircleFilled} from  '@ant-design/icons';

import {  GET_DATA_EXPORT_TABLE_LIST, GET_EXPORT_COLUMN_LIST, GET_DATA_EXPORT_SCHEMA_LIST, GET_VIEW_DATA, EXPORT_DATA, DELETE_DATA_EXPORT, GET_DATA_EXPORT_LIST, ADD_DATA_EXPORT, 
	UPDATE_DATA_EXORT, GET_DATA_EXPORT_TABLE_VIEW_LIST, GET_DATA_EXPORT_HISTORY_LIST, DELETE_DATA_EXPORT_HISTORY} from "redux/constants/dataExport";

import {  showDataMigrationMessage, dataExportTableList,viewData,columnList, schemaList, dataExportList, tableViewList,dataExportHistoryList } from "redux/actions/dataExport";
import { showUnAutherizeMessage} from "redux/actions/Auth";

import { API_ENDPOINT_DATA_MIGRATION, DATA_MIGRATION, VERSION, MANAGE_PREPIX_PATH, API_ENDPOINT_BLOG_STORAGE_URL, API_BASE_DEVELOPER_APP, API_ENDPOINT_DATA_EXPORT, DATA_EXPORT } from 'configs/AppConfig';
import {
	AUTH_TOKEN,
} from '../constants/Auth';
import { t } from "i18next";
import { saveAs } from 'file-saver';
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";

export function* getDataExportTableList(){
    yield takeEvery (GET_DATA_EXPORT_TABLE_LIST, function*  ({requestData}){
	    const {query, sorter,pagination,appId,appInstanceId} = requestData;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table?appId=${appId}&appInstanceId=${appInstanceId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_data_export_table_list`,
						event: 'click',
						message: `Keyword=${query}`,
						status: `Data Export Table List Retrieve Sucessfully `,
						action: `Search Data Export Table List`,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_data_export_table_list`,
					event: 'click',
					message: `${res?.data?.totalElements} results found`,
					status: `Data Export Table List Retrieve Sucessfully `,
					action: `Clicked Data Export Table List`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(dataExportTableList(res.data));
			} 
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_data_export_table_list`,
					event: 'click',
					message: `Keyword=${query}`,
					status: `Failed To Retrieve Data Export Table List `,
					action: `Search Data Export Table List`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_data_export_table_list`,
				event: 'click',
				message: `0 results found`,
				status: `Failed To Retrieve Data Export Table List `,
				action: `Clicked Data Export Table List`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}

export function* getDataViewTableList(){
    yield takeEvery (GET_DATA_EXPORT_TABLE_VIEW_LIST, function*  ({requestData}){
	    const {query, sorter,pagination,schemaName} = requestData;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/table?schemaName=${schemaName}`,
		config);
			if (res.status===200) {
				const traceObj ={
					type: `get_data_view_table_list`,
					event: 'click',
					message: `Data View Table List Retrieve For SchemaName=${schemaName} `,
					status: `Data View Table List Retrieve Sucessfully`,
					action: `Clicked data view table list`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				yield put(tableViewList(res.data));
			} 
		} catch (err) {
			const traceObj ={
				type: `get_data_view_table_list`,
				event: 'click',
				message: `Failed To Retrieve Data View Table List For SchemaName=${schemaName} `,
				status: `Failed To Retrieve Data View Table List`,
				action: `Clicked data view table list`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}

export function* getSchemaList(){
    yield takeEvery (GET_DATA_EXPORT_SCHEMA_LIST, function*  ({requestData}){
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/schema`,
		config);
			if (res.status===200) {
				const traceObj ={
					type: `get_schema_list`,
					event: 'click',
					message: `${res?.data?.totalElements} results found`,
					status: `Retrieve Schema List Sucessfully`,
					action: `Clicked get schema list`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				yield put(viewData(res.data));
				yield put(schemaList(res.data));
			} 
		} catch (err) {
			const traceObj ={
				type: `get_schema_list`,
				event: 'click',
				message: `0 results found`,
				status: `Failed To Retrieve Schema List`,
				action: `Clicked get view data`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}

export function* getViewData(){
    yield takeEvery (GET_VIEW_DATA, function*  ({payload}){
	    const {appInstanceId,schemaName,tableName,appId,query,sorter,pagination} = payload;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId"),accountId: localStorage.getItem("accountId") }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/viewdata?tableName=${tableName}&
        schemaName=${schemaName}&appInstanceId=${appInstanceId}&appId=${appId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&
		page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				const traceObj ={
					type: `get_view_data`,
					event: 'click',
					message: `Retrieve View Data For Table =${tableName} `,
					status: `Retrieve View Data Sucessfully`,
					action: `Clicked get view data`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				yield put(viewData(res.data));
			} 
		} catch (err) {
			const traceObj ={
				type: `get_view_data`,
				event: 'click',
				message: `Failed To Retrieve View Data For Table =${tableName} `,
				status: `Failed To Retrieve View Data`,
				action: `Clicked get view data`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}


export function* getExportData(){
    yield takeEvery (EXPORT_DATA, function*  ({payload}){
	    const {appInstanceId,schemaName,tableName,appId} = payload;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId"),
		responseType: 'blob',
	 }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/send-to-rabbitmq-and-export?tableName=${tableName}&
		schemaName=${schemaName}&appInstanceId=${appInstanceId}&appId=${appId}&userId=${localStorage.getItem("userId")}`,
		config);
			if (res.status===200) {
				const traceObj ={
					type: `get_export_data`,
					event: 'click',
					message: `Data Export For Table =${tableName} `,
					status: `Data Export Sucessfully`,
					action: `Clicked get data export`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				const arrayBuffer =  res.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	
				// Create a Blob and trigger the download
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'example.xlsx');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} 
		} catch (err) {
			const traceObj ={
				type: `get_export_data`,
				event: 'click',
				message: `Failed To Export Data For Table =${tableName} `,
				status: `Failed To Export Data`,
				action: `Clicked get data export`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}
export function* getDataExportList(){
    yield takeEvery (GET_DATA_EXPORT_LIST, function*  ({requestData}){
	    const {query, sorter,pagination,appId,appInstanceId} = requestData;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table?appId=${appId}&appInstanceId=${appInstanceId}
		&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_data_export_list`,
						event: 'click',
						message: `Keyword=${query}`,
						status: `Data Export List Retrieve Sucessfully `,
						action: `Search data export list `,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_data_export_list`,
					event: 'click',
					message: `${res?.data?.totalElements} results found`,
					status: `Data Export List Retrieve Sucessfully`,
					action: `Clicked get data export list `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(dataExportList(res.data));
			} 
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_data_export_list`,
					event: 'click',
					message: `Keyword=${query}`,
					status: `Failed To Retrieve Data Export List`,
					action: `Search data export list `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_data_export_list`,
				event: 'click',
				message: `0 results found`,
				status: `Failed To Retrieve Data Export List`,
				action: `Clicked get data export list `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err?.response?.data?.status==401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}

export function* getDataExportHistoryList(){
    yield takeEvery (GET_DATA_EXPORT_HISTORY_LIST, function*  ({requestData}){
	    const {query, sorter,pagination,appId,appInstanceId} = requestData;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/data-export-history?accountId=${localStorage.getItem("accountId")}
		&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				yield put(dataExportHistoryList(res.data));
			} 
		} catch (err) {
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}


export  function* addDataExport(){
	yield takeEvery(ADD_DATA_EXPORT, function* ({payload}){
		const {values,query,sorter,pagination,appId,appInstanceId}=payload
		try {
			const res = yield  axios.post(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table`,values,{headers :{
				'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				'Access-Control-Allow-Origin' : '*',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				accountUserId: localStorage.getItem("accountUserId")
			  }});
				if (res.status===200) {
					const traceObj ={
						type: `add_data_export`,
						event: 'click',
						message: `Data Export Added Sucessfully`,
						status: `Data Export Added Sucessfully`,
						action: `Clicked add data export `,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					const response = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table?appId=${appId}&appInstanceId=${appInstanceId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
					{headers: {
					   'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
					   'Access-Control-Allow-Origin' : '*',
					   'Accept': 'application/json',
					   'Content-Type': 'application/json',
					   accountUserId: localStorage.getItem("accountUserId")
					 }});
					   if (response.status===200) {
							Modal.success({
								title: `${values.tableName}  ${t("impaqx.adminApp.dataExortAddMessage")}`,
								icon: <CheckCircleFilled />,
								okText: 'Close',
								onOk() {
								},
							});
						}
								yield put(dataExportList(response.data))
				}else{
					yield put(showDataMigrationMessage(res));
				}
			} catch (err) {
				const traceObj ={
					type: `add_data_export`,
					event: 'click',
					message: `Failed To Add Data Export`,
					status: `Failed To Add Data Export`,
					action: `Clicked add data export `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				console.log(err);
				if(err.response.data.status===401){
					yield put(showUnAutherizeMessage(err.response));
				}
				yield put(showDataMigrationMessage(err.response));
			}
	}
	)
}


export function* updateDataExport(){
    yield takeEvery (UPDATE_DATA_EXORT,function* ({payload}){
		const {values,query,sorter,pagination,appId,appInstanceId} = payload;
        try {
            const res = yield axios.put(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table/${values.id}`, values,{
				headers: {
				  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  'Access-Control-Allow-Origin' : '*',
				  'Accept': 'application/json',
				  'Content-Type': 'application/json',
				  accountUserId: localStorage.getItem("accountUserId")
				}
			  });
             if (res.status===200) {
				const traceObj ={
					type: `update_data_export`,
					event: 'click',
					message: `Data Export Updated Sucessfully For Id=${values.id}`,
					status: `Data Export Updated Sucessfully`,
					action: `Clicked update data export `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				const response = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table?appId=${appId}&appInstanceId=${appInstanceId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
				{headers: {
				   'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				   'Access-Control-Allow-Origin' : '*',
				   'Accept': 'application/json',
				   'Content-Type': 'application/json',
				   accountUserId: localStorage.getItem("accountUserId")
				 }});
				   if (response.status===200) {
					Modal.success({
						title: `${values.tableName}  ${t("impaqx.adminApp.dataExportUpdatedMessage")}`,
						icon: <CheckCircleFilled />,
						okText: 'Close',
						onOk() {
						},
					});
				}
                 yield put(dataExportList(response.data));
             } 
        } catch (error) {
			const traceObj ={
				type: `update_data_export`,
				event: 'click',
				message: `Failed To Update Data Export For Id=${values.id}`,
				status: `Failed To Update Data Export`,
				action: `Clicked update data export `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
            console.log(error);
			if(error.response.data.status===401){
				yield put(showUnAutherizeMessage(error.response));
			}
			yield put(showDataMigrationMessage(error.response));
        }
    }
    )
}

export function* deleteDataExport(){
	yield takeEvery(DELETE_DATA_EXPORT, function*({payload}){
         try {
			const {dataExport,query, sorter,pagination,appId,appInstanceId} = payload;
			 const res = yield axios.delete(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table/${dataExport.id}`,{
				headers: {
				  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  'Access-Control-Allow-Origin' : '*',
				  'Accept': 'application/json',
				  'Content-Type': 'application/json',
				  accountUserId: localStorage.getItem("accountUserId")
				}
			  });
			 if(res.status===200){
					  const traceObj ={
					type: `delete_data_export`,
					event: 'click',
					message: `Data Export Deleted Sucessfully For Id=${dataExport.id}`,
					status: `Data Export Deleted Sucessfully`,
					action: `Clicked delete data export `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				
				const response = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/export-table?appId=${appId}&appInstanceId=${appInstanceId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
				{headers: {
				   'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				   'Access-Control-Allow-Origin' : '*',
				   'Accept': 'application/json',
				   'Content-Type': 'application/json',
				   accountUserId: localStorage.getItem("accountUserId")
				 }});
				   if (response.status===200) {
					Modal.success({
						title: `${dataExport.tableName}  ${t("impaqx.adminApp.dataExportDeleteMessage")}`,
						icon: <CheckCircleFilled />,
						okText: 'Close',
						onOk() {
						},
					});
				}
                 yield put(dataExportList(response.data));
			 }
		 } catch (error) {
			const traceObj ={
				type: `delete_data_export`,
				event: 'click',
				message: `Failed To Delete Data Export`,
				status: `Failed To Delete Data Export`,
				action: `Clicked delete data export `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			 console.log(error);
			 if(error.response.data.status===401){
				yield put(showUnAutherizeMessage(error.response));
			}
			 yield put(showDataMigrationMessage(error.response));
		 }
	})
}

export function* deleteDataExportHistory(){
	yield takeEvery(DELETE_DATA_EXPORT_HISTORY, function*({payload}){
         try {
			const {dataExportHistory,query, sorter,pagination,appId,appInstanceId} = payload;
			 const res = yield axios.delete(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/data-export-history/${dataExportHistory.id}`,{
				headers: {
				  'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  'Access-Control-Allow-Origin' : '*',
				  'Accept': 'application/json',
				  'Content-Type': 'application/json',
				  accountUserId: localStorage.getItem("accountUserId")
				}
			  });
			 if(res.status===200){
					const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/data-export-history?accountId=${localStorage.getItem("accountId")}
					&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
					{headers: {
						'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
						'Access-Control-Allow-Origin' : '*',
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						accountUserId: localStorage.getItem("accountUserId")
					  }});
						if (res.status===200) {
							yield put(dataExportHistoryList(res.data));
					} 
			 }
		 } catch (error) {
			 console.log(error);
			 if(error.response.data.status===401){
				yield put(showUnAutherizeMessage(error.response));
			}
			 yield put(showDataMigrationMessage(error.response));
		 }
	})
}

export function* getColumnList(){
    yield takeEvery (GET_EXPORT_COLUMN_LIST, function*  ({requestData}){
	    const {schemaName,tableName} = requestData;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_ENDPOINT_DATA_EXPORT}${DATA_EXPORT}${VERSION}/columns?tableName=${tableName}&schemaName=${schemaName}`,
		config);
			if (res.status===200) {
				yield put(columnList(res.data));
			} 
		} catch (err) {
			console.log(err);
			if(err?.response?.data?.status===401){
				yield put(showUnAutherizeMessage(err.response));
			}
			yield put(showDataMigrationMessage(err.response));
		}
    }

    )
}

export default function* rootSaga(){
    yield all([
		  fork(getDataExportTableList),
		  fork(addDataExport),
		  fork(deleteDataExport),
		  fork(updateDataExport),
		  fork(getSchemaList),
		  fork(getViewData),
		  fork(getExportData),
		  fork(getDataExportList),
		  fork(getDataViewTableList),
		  fork(getDataExportHistoryList),
		  fork(deleteDataExportHistory),
		  fork(getColumnList)
    ])
    
}